import { render } from "./PageHeader.vue?vue&type=template&id=ee680054&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=ee680054&lang=less&scoped=true"
import "./PageHeader.vue?vue&type=style&index=1&id=ee680054&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee680054"]])

export default __exports__